import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";
import { Flame, Video, Zap, Users } from "lucide-react";

const ITEMS = [
  { icon: Flame, value: "45,000+", title: "Facebook Posts", body: "A decade-deep content vault that compounds engagement daily.", color: "#00F0FF", tid: "content-fb" },
  { icon: Video, value: "450+", title: "YouTube Videos", body: "Long-form narratives with editorial rigour — not reaction slop.", color: "#FF00FF", tid: "content-yt" },
  { icon: Zap, value: "∞", title: "Viral Storytelling", body: "An in-house playbook for engineering moments that command feeds.", color: "#FFDE00", tid: "content-viral" },
  { icon: Users, value: "Top-Tier", title: "High Recall Among Youth", body: "A brand the 16–34 audience trusts, quotes, and defends online.", color: "#00F0FF", tid: "content-recall" },
];

const ContentPower = () => {
  return (
    <SectionWrapper id="content">
      <SectionHeader
        code="// CH.04 — OUTPUT"
        title="Content.OS"
        kicker="Each module is a high-voltage data node — a decade of storytelling wired for scale."
        tid="content"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <Reveal key={it.tid} delay={i * 0.06}>
              <div
                className="glass-card hud-corners p-7 md:p-10 h-full flex flex-col md:flex-row gap-6 items-start"
                data-testid={it.tid}
              >
                <span className="hud-tr" />
                <span className="hud-bl" />
                <div
                  className="w-14 h-14 flex items-center justify-center border flex-none"
                  style={{ borderColor: `${it.color}66`, color: it.color, boxShadow: `inset 0 0 20px ${it.color}22, 0 0 20px ${it.color}22` }}
                >
                  <Icon size={22} strokeWidth={1.4} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="micro-label" style={{ color: it.color }}>
                      MODULE · {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="micro-label text-white/35">ACTIVE</span>
                  </div>
                  <div
                    className="font-display font-black text-3xl md:text-4xl tracking-tight leading-none mb-1 interactive-text"
                    style={{ color: it.color }}
                  >
                    {it.value}
                  </div>
                  <div className="font-display font-bold uppercase text-lg md:text-xl text-white/90 tracking-tight mt-2">
                    {it.title}
                  </div>
                  <p className="text-white/60 text-sm md:text-base mt-3 leading-relaxed">
                    {it.body}
                  </p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </SectionWrapper>
  );
};

export default ContentPower;
